'use client';

import React from 'react';
import LayoutWhatWeDoCarouselMobile from './LayoutWhatWeDoCarouselMobile';
import LayoutWhatWeDoCarouselDesktop from './LayoutWhatWeDoCarouselDesktop';

export default function WhatWeDoCarousel() {

  // Carousel images and videos with explicit widths (at 500px height) and spacing
  const carouselData = [
    { src: '/images/case-studies/brooklyn-film-festival/loading-result.mp4', width: 389, alt: 'Brooklyn Film Festival looping video' },
    { src: '/images/what-we-do/aa2-thumb.png', width: 600, alt: 'American Airlines thumbnail image' },
    { src: '/images/case-studies/staybl/staybl-desktop.mp4', width: 400, alt: 'Staybl looping video' },
    { src: '/images/what-we-do/carousel-hos.png', width: 438, alt: 'House of Suntory' },
    { src: '/images/what-we-do/fitbit-thumb.png', width: 600, alt: 'Google Fitbit thumbnail image' },
    { src: '/images/what-we-do/carousel-aa.png', width: 500, alt: 'American Airlines thumbnail image' },
    { src: '/images/case-studies/brooklyn-film-festival/bffawwwards.mp4', width: 700, alt: 'Brooklyn Film Festival awards looping video' },
    { src: '/images/what-we-do/carousel-hos2.png', width: 438, alt: 'House of Suntory thumbnail image' },
  ];

  const carouselImages = carouselData.map(item => item.src);
  const carouselWidths = carouselData.map(item => item.width);
  const carouselAltTexts = carouselData.map(item => item.alt);

  return (
    <section 
      className="w-full overflow-x-hidden pt-[3rem] pb-[3rem] lg:pt-[6.25rem] lg:pb-[5.1875rem]"
      style={{
        backgroundImage: 'radial-gradient(circle at 0.0625rem 0.0625rem, #8DC1FF 0.0625rem, transparent 0)',
        backgroundSize: '1.25rem 1.25rem',
      }}
    >
      {/* Mobile carousel */}
      <LayoutWhatWeDoCarouselMobile images={carouselImages} altTexts={carouselAltTexts} />

      {/* Desktop carousel */}
      <LayoutWhatWeDoCarouselDesktop images={carouselImages} widths={carouselWidths} altTexts={carouselAltTexts} />
    </section>
  );
}

